import { RootState } from 'src/store';

import { IAuth } from './types';

export const selectAuth = (state: RootState): IAuth => state.auth;
export const selectUserToken = (state: RootState): string | null => state.auth.token;
